import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const SlidesTabs = Loadable({
    loader: () => import(/* webpackChunkName: "SlidesTabs" */ './slidesTabs'),
    loading: () => <div />,
});
export const MoreTabs = Loadable({
    loader: () => import(/* webpackChunkName: "MoreTabs" */ './moreTabs'),
    loading: () => <div />,
});
export const MarkTabs = Loadable({
    loader: () => import(/* webpackChunkName: "MarkTabs" */ './markTabs'),
    loading: () => <div />,
});
export const NormalTabs = Loadable({
    loader: () => import(/* webpackChunkName: "NormalTabs" */ './normalTabs'),
    loading: () => <div />,
});
export const ViewMoreLink = Loadable({
    loader: () => import(/* webpackChunkName: "ViewMoreLink" */ './viewMoreLink'),
    loading: () => <div />,
});
